import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
  {
    path: '/:lang(zh|en)/:event_id(\\d+)',
    name: 'home',
    component: () => import('../views/isShowPoster.vue'),
    alias: ['/', '/draft', '/draft/:lang(zh|en)/:event_id(\\d+)'],

  },
  {
    path: '/:lang(zh|en)/:event_id(\\d+)/detail/:id', // 通用移动端二级页面
    name: 'detail',
    alias: ['/detail/:id', '/draft/detail/:id', '/draft/:lang(zh|en)/:event_id(\\d+)/detail/:id'],
    component: () => import('../views/detail/index.vue')
  }, {
    path: '/:lang(zh|en)/:event_id(\\d+)/newsList/:id', // 移动端新闻列表
    alias: ['/newsList/:id', '/draft/newsList/:id', '/draft/:lang(zh|en)/:event_id(\\d+)/newsList/:id'],

    name: 'newsList',
    component: () => import('../views/newsList/index.vue')
  }, {
    path: '/:lang(zh|en)/:event_id(\\d+)/newsdetail', // 移动端新闻--详情
    alias: ['/newsdetail', '/draft/newsdetail/:id', '/draft/:lang(zh|en)/:event_id(\\d+)/newsdetail'],
    name: 'newsdetail',
    component: () => import('../views/newsList/detail.vue')
  },

  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: '/:lang(zh|en)/:event_id(\\d+)/404',
    component: () => import('../views/404'),
    alias: ['/404', '/draft/404/', '/draft/:lang(zh|en)/:event_id(\\d+)/404'],

    hidden: true
  },
  { path: '*', redirect: '/404', hidden: true }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
